// 三轨道只管理显示事件；不读取聊天历史，不改变消息权限、原文或胜负判定。
export const MARQUEE_LANES = 3;
export const VICTORY_PLAYS = 3; // 保留P84胜负公告原有三次完整播放。
export const MARQUEE_GAP = 28;

export function victoryAnnouncement(game, roomId) {
  if (!roomId || !game || game.id || !["idle", "ended"].includes(game.status) ||
      !game.endedAt || !["good", "evil"].includes(game.winner)) return null;
  return {
    key: JSON.stringify([roomId, game.number, game.endedAt, game.winner]),
    gameNumber: game.number, winner: game.winner, endedAt: game.endedAt,
    text: game.winner === "evil" ? "本局游戏结束，邪恶阵营获胜！" : "本局游戏结束，善良阵营获胜！",
    played: 0
  };
}

export class MarqueeScheduler {
  constructor() {
    this.queue = [];
    this.active = [];
    this.known = new Set();
    this.announcement = null;
    this.serial = 0;
    this.cursor = 0;
    this.lastKind = "announcement";
  }
  enqueue(items) {
    for (const item of items) {
      if (!item?.original?.id || this.known.has(item.original.id)) continue;
      this.known.add(item.original.id);
      this.queue.push(item);
    }
    // 与既有P84一致：最多200条待播，极端溢出保留聊天全文并明确提示。
    const dropped = Math.max(0, this.queue.length - 200);
    this.queue.splice(0, dropped);
    const protectedIds = new Set([...this.queue, ...this.active].map(i => i.original.id));
    for (const id of this.known) {
      if (this.known.size <= 2048) break;
      if (!protectedIds.has(id)) this.known.delete(id);
    }
    return dropped;
  }
  setAnnouncement(notice) {
    const key = notice?.key || "";
    const cancelled = this.active.filter(i => i.kind === "announcement" && i.announcementKey !== key);
    this.active = this.active.filter(i => !cancelled.includes(i));
    if (!key) this.announcement = null;
    else if (this.announcement?.key === key) {
      this.announcement.played = Math.max(this.announcement.played, notice.played || 0);
    } else this.announcement = { ...notice };
    return cancelled;
  }
  announcementReady() {
    return this.announcement && this.announcement.played < VICTORY_PLAYS &&
      !this.active.some(i => i.kind === "announcement");
  }
  hasPending() { return this.queue.length > 0 || !!this.announcementReady(); }
  canEnter(track, speed, viewport, now) {
    return this.active.filter(i => i.track === track).every(previous => {
      const remaining = previous.viewport + previous.width - previous.speed * Math.max(0, now - previous.startedAt) / 1000;
      const gap = viewport - remaining;
      if (remaining <= 0) return true;
      // 除入口间距，还预测直到前一条完全离屏，防止快的短句追尾长句。
      const closing = Math.max(0, speed - previous.speed) * remaining / previous.speed;
      return gap - closing >= MARQUEE_GAP;
    });
  }
  pump(now, viewport, makeAnnouncement) {
    const started = [], speed = Math.max(1, viewport * .117);
    while (this.hasPending()) {
      let track = -1;
      for (let n = 0; n < MARQUEE_LANES; n++) {
        const candidate = (this.cursor + n) % MARQUEE_LANES;
        if (this.canEnter(candidate, speed, viewport, now)) { track = candidate; break; }
      }
      if (track < 0) break;
      // 两类竞争时交替入场；公告至多一条在飞，不复制到普通队列。
      const isAnnouncement = this.announcementReady() && (!this.queue.length || this.lastKind !== "announcement");
      const item = isAnnouncement ? makeAnnouncement(this.announcement) : this.queue.shift();
      if (!item) break;
      const kind = isAnnouncement ? "announcement" : "ordinary";
      const flight = { ...item, id: "marquee-" + (++this.serial), track, kind, speed, viewport, startedAt: now };
      if (isAnnouncement) {
        flight.announcementKey = this.announcement.key;
        flight.play = ++this.announcement.played;
      }
      this.active.push(flight); started.push(flight);
      this.lastKind = kind;
      this.cursor = (track + 1) % MARQUEE_LANES;
    }
    return started;
  }
  finish(id) {
    const item = this.active.find(i => i.id === id);
    this.active = this.active.filter(i => i.id !== id);
    return item;
  }
  reset() {
    this.queue = []; this.active = []; this.known.clear(); this.announcement = null;
    this.cursor = 0; this.lastKind = "announcement";
  }
}
